export class ProductDropdownTemplate {
    constructor(_refs) {
        this._refs = {..._refs};        
    }

    /**
     * Create template
     * @returns {String}
     */
    createTemplate() {
        if(!this._refs.data) return;
        const titleTemplate = this.createTitle();
        let itemsTemplate = '';
        // create template for each Side (left or right) / tube-type
        for(let contentItem of this._refs.data) {
            itemsTemplate += this.createContentItem(contentItem);
        }

        const template = `
        <div class="configurator__accessories-list configurator__dropdown">
            ${titleTemplate}
            ${itemsTemplate}
        </div>`;

        return template;
    }

    createTitle() {
        if(!this.title) return '';
        return `
            <span class="configurator__accessories-title">${this._refs.labels.title}</span>
        `;
    }

    /**
     * Create wrapper for dropdown selector
     * @param {Object} contentData 
     * @returns {String}
     */
    createContentItem(contentData) {
        let itemsTemplate = '';
        let addMoreBTNTemplate = '';
        this._refs.bundle = contentData.isBundle;
        for(let data of contentData.data) {
            itemsTemplate += this.createItem(data, contentData.attrValues, contentData.image);
        }
        // If bundle Add More button should not be visible 
        if(!this._refs.bundle) {
            addMoreBTNTemplate += this.createAddMoreButton(contentData);
        }
        return `
            <div class="configurator__accessories-content_item item_${contentData.attrValues.toLowerCase()}" data-item="${contentData.attrValues.toLowerCase()}">
                <div class="item_wrapper">
                    ${itemsTemplate}
                </div>
                ${addMoreBTNTemplate}
            </div>
        `;
    }

    /**
     * Create dropdown selector
     * @param {Array} data 
     * @param {String} item 
     * @param {String} image 
     * @returns {String}
     */
    createItem(data, item, image) {
        // add quantity on page refresh / postback
        const quantityValue = data.map(obj => obj.selected).filter(el => el && el > 0);
        const textBox = document.querySelector(`#${data[0].inputID}`);
        const inputMin = textBox?.getAttribute('min') ?? 0;
        const inputMax = textBox?.getAttribute('max') ?? 2;
        const inputMaxLenght = textBox?.getAttribute('maxlength') ?? 5;
        const quantityField = `
        <div class="configurator__accessory-input">
            <div class="configurator__accessory-quantity">
                <div class="number-input">
                    <button class="number-input__button number-input__button--minus is-disabled" type="button" lang="en" title="Minus" aria-label="Minus" aria-disabled="true" tabindex="-1"></button>
                    <input class="number-input__field" name="receiver__2-quantityInput" role="region" aria-live="assertive" type="text" maxlength="${inputMaxLenght}" value="${quantityValue.length <= 0 ? 0 : quantityValue[0]}" autocomplete="off" min="${inputMin}" max="${inputMax}">
                    <button class="number-input__button number-input__button--plus" type="button" lang="en" title="Plus" aria-label="Plus" aria-disabled="false" tabindex="0"></button>
                </div>
            </div>
        </div>
        `;

        return `
        <div class="configurator__accessories-item">   
            <div class="configurator__accessory-inner">
                <div class="configurator__accessory-image">
                    <img class="accessoryImage" alt="" src="${image}">
                </div>
                <div class="configurator__accessory-content">
                    <div class="form-select" data-select>
                        <select data-item="${item}">
                            ${this.createOptions(data, item)}
                        </select>
                    </div>
                </div>
                ${this._refs.bundle ? '' : quantityField}
            </div>
        </div>
        `;
    }

    /**
     * Create option elements to dropdowwn
     * @param {Array} dataList 
     * @param {String} item 
     * @returns {String}
     */
    createOptions(dataList, item) {
        const toCapitalCase = (string) => {
            if(string.length > 0) {
                const firstLetter = string[0];
                return string.replace(firstLetter, firstLetter.toUpperCase());
            }
        }
        let isSelected = dataList.map(item => item.selected).filter(item => item);
        let label = this._refs.accessoryType === 'domes' ?  this._refs.labels.selectDome : this._refs.labels[`select${toCapitalCase(item)}`];
        
        let optionTemplate = `<option value="" ${isSelected.length > 0 ? '' : 'selected'}>${label}</option>`;
        for(let data of dataList) {
            const disableField = this._refs.selectedItems.includes(data.inputID);
            optionTemplate += `<option value="${data.inputID}" ${data.selected ? 'selected' : ''} ${disableField ? 'disabled' : ''} data-sublabel="${data.sku}">${data.label}</option>`;
        }
        return optionTemplate;
    }

    /**
     * Create button to add more dropdown
     * @param {Object} data 
     * @returns {String}
     */
    createAddMoreButton(data) {
        const item = data.attrValues.toLowerCase();
        return `
        <div class="configurator__addMore" data-item="${item}">   
            <div class="configurator__accessory-inner addMore__inner">
                <button type="button" class="addAccessoryDropdown" data-item="${item}">+ ${this._refs.labels.buttonLabel}</button>
            </div>
        </div>
        `;
    }
}